import { SETCARTCOUNT, SETCARTDATA, SETCARTTOTALPRICE, } from "../redux/features/CartData";
import { GetTotalPrice } from "./GetTotalPrice";
import { TaxCalcualate } from "./TaxCalculate";
import { Dispatch } from "redux";
import Konsole from "./konsole/Konsole";
import { CheckIsMeal } from "./CustomizedCalculation/MealPrice";
// import GetCustomizedSubTotal from "./CustomizedCalculation/GetSubTotal";
const incrementItemData = (data: any, cardData: any, disPatch: Dispatch, itemCount: number, taxdata?: any,quantity?:number) => {

  const index = cardData.indexOf(data);
  // const TaxData = TaxCalcualate(taxdata, Number(data?.sub_total) + Number(data?.web_price),  Number(data.quantity) + 1);
  // const total_price = Number(data?.total_price) + Number(data?.web_price) + TaxData.fixedTax + (Number(data?.web_price) * TaxData.percentageTax) / 100;
  // console.log('asdftotal_price',data, total_price)
  data["quantity"] = Number(data.quantity) + (quantity || 1);
  data["sub_total"] = Number(data?.sub_total);
  
  data['textdata_for_page']='';
    // for redux serial error
  Konsole.log('datadata', data)
  let fromAdOn=data?.from_ad_on===true;
  let sub_price=parseFloat((data?.customize_status == 1 || CheckIsMeal(data?.is_meal)  || fromAdOn===true) ? data.sub_total : data?.price);
//console.log('_sub_pricesub_price',data,sub_price)
    // console.log("_data",data?.from_ad_on,data)
  // data["total_price"] =  Number(data?.total_price) + Number(data?.web_price) + TaxData.fixedTax + (Number(data?.web_price) * TaxData.percentageTax) / 100;
  data['total_price'] = parseFloat(data.total_price) +(sub_price * (quantity || 1)); 

  const TaxData = TaxCalcualate(taxdata, Number(data.total_price), Number(data.quantity) + (quantity || 1));

  data["tax_rate_list"] = TaxData.taxArray;
  cardData.splice(index, 1, data);
  disPatch(SETCARTDATA(cardData));
  Konsole.log('cardDatacardData', cardData)
  disPatch(SETCARTTOTALPRICE(GetTotalPrice(cardData)));
  disPatch(SETCARTCOUNT(itemCount + (quantity || 1)));
  sessionStorage.setItem("items", JSON.stringify(cardData));
};
export default incrementItemData;
